import React from 'react';

/**
 * PreviewModeBanner
 *
 * A small, presentational notice strip shown at the top of an assessment
 * proforma when it has been opened in "preview" (read-only) mode — i.e. via a
 * Preview button on the Patient Overview, which appends `?preview=true` to the
 * route.
 *
 * Why this exists as its own component
 * ------------------------------------
 * Several modules (History, Observation, and now the Diagnostic Decision and
 * Post-Assessment Discussion wizards) need to tell a viewer "you're only
 * looking, you can't change anything here". Previously each page inlined its
 * own copy of this banner, and the wording had already drifted apart between
 * modules. Centralising it in one component keeps the message and styling
 * identical everywhere, so a clinician sees the same cue no matter which
 * appointment they preview, and there is a single place to update the copy.
 *
 * It is intentionally "dumb": it renders nothing conditionally and takes no
 * props. Each page decides WHEN to show it (typically `{isPreviewMode && <PreviewModeBanner />}`),
 * which keeps the component trivial to test and reuse.
 */
export default function PreviewModeBanner() {
  return (
    <div className="flex-shrink-0 px-8 py-2 bg-blue-50 border-b border-blue-100">
      <p className="text-sm text-blue-800">
        Preview mode — viewing only. Notes and decisions are read-only.
      </p>
    </div>
  );
}
